import instance from '../scorpiusInstance';
import {
  FETCH_APP_ROLES_START,
  FETCH_APP_ROLES_SUCCESS,
  FETCH_APP_ROLES_ERROR,
} from '../types';

export const fetchAppRolesStart = (orgId, appName) => ({
  type: FETCH_APP_ROLES_START,
  orgId,
  appName,
});

export const fetchAppRolesSuccess = (orgId, appName, roles) => ({
  type: FETCH_APP_ROLES_SUCCESS,
  orgId,
  appName,
  roles,
});

export const fetchAppRolesError = (orgId, appName, error) => ({
  type: FETCH_APP_ROLES_ERROR,
  orgId,
  appName,
  error,
});

/**
 * Fetch all roles for an organization's application.
 * @param {String} orgId
 * @param {String} appName
 */
export const fetchAppRoles = (orgId, appName) => async dispatch => {
  dispatch(fetchAppRolesStart(orgId, appName));
  try {
    const response = await instance.get(
      `/organizations/${orgId}/${appName}/roles`,
      { headers: { retry: true } },
    );
    return dispatch(fetchAppRolesSuccess(orgId, appName, response.data));
    // return dispatch(fetchAppRolesSuccess(orgId, appName, rolesMock));
  } catch (error) {
    throw dispatch(fetchAppRolesError(orgId, appName, error));
  }
};

export default fetchAppRoles;
